module.exports = __webpack_public_path__ + "static/datatable-link-dont-ee19e13e1384e3b6d0b08d89d7a6d56f.png";